import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { updatePatientOrderStatus} from '../../services/transaction.service';
import { updateTransactionBatchStatus, updateTransactionCodeStatus } from '../../services/transaction.service';
import { FormControl, FormLabel, makeStyles, TextField, Typography, Box, Select, MenuItem } from '@material-ui/core';

import { getProductBrandList } from '../../services/product.service';

import Dialog from '../ui/Dialog';

const TransactionBatchorCodeApproval = ({ data }) => {
    const { id, transaction_status, program_id, transaction_type, transation_code_id, initial_scheme_id, maintenance_scheme_id, child_program_id } = data;
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmation, setConfirmation] = useState(false);
    const [modalTitle, setModalTitle] = useState("Rejection Transaction Batch");
    const [successMessage, setSuccessMessage] = useState('');
    const [rejectionNotes, setRejectionNotes] = useState("");
    const [openConfirm, setOpenConfirm] = useState(false);
    
    const [initialOptions, setInitialOptions] = useState<any[]>([]);
    const [maintenanceOptions, setMaintenanceOptions] = useState<any[]>([]);
    const [allSchemes, setAllSchemes] = useState<any[]>([]);
    const [selectedIp, setSelectedIp] = useState<string>("");
    const [selectedMp, setSelectedMp] = useState<string>("");
    const [changeScheme, setChangeScheme] = useState("no");

    const useStyles = makeStyles(() => ({
        field: {
          marginBottom: 20,
        },  
        formControl: {
          width: '250%'
        }
    }));
      
    const classes = useStyles();

     useEffect(() => {
            const getSchemes = async () => {
                if (child_program_id?.includes('soliris')) {
                    const schemes = await getProductBrandList(child_program_id);
    
                // 1 Extract all schemes from brands
                const allSchemes = schemes.flatMap(
                    (brand: any) => brand?.brand_metadata?.schemes || []
                );
                setAllSchemes(allSchemes);
                // 2️ Separate initial & maintenance
                const initialPhase = allSchemes.filter((scheme: any) =>
                    scheme.scheme_id?.includes('initial_phase')
                );
    
                const maintenancePhase = allSchemes.filter((scheme: any) =>
                    scheme.scheme_id?.includes('maintenance_phase')
                );
    
                // 3️ Convert to dropdown format
                const formattedInitial = initialPhase.map((scheme: any) => ({
                    label: scheme.scheme_label,
                    value: scheme.scheme_id,
                }));
    
                const formattedMaintenance = maintenancePhase.map((scheme: any) => ({
                    label: scheme.scheme_label,
                    value: scheme.scheme_id,
                }));
    
                setInitialOptions(formattedInitial);
                setMaintenanceOptions(formattedMaintenance);
    
                // 4️ Set default selected values
                setSelectedMp("");
                }
            }
            getSchemes();
        }, [child_program_id]);  
 
    const onClick = async (action: string) => {
        if (window.confirm(`Do you want to ${action} this Transaction?`)) {
            if (action === "approve") {
                setOpenConfirm(true);              
            }

            if (action === "reject") {
               setOpenModal(true);
            }
        }
    };

    const onReject = async () => {
        try {
            let res;
            if (transaction_type === "free_good") {
                 res = await updateTransactionCodeStatus({
                     id: transation_code_id,
                     connect_program_id: program_id,
                     action: 'reject',
                     registration_rejection_notes: rejectionNotes
                }); 
            } else {
                res = await updateTransactionBatchStatus({
                    connect_program_id: program_id, id, action: 'reject',
                    registration_rejection_notes: rejectionNotes
                });
                 
            }

            setOpenModal(false); 
            alert(res.message);           
            window.location.reload();
        } catch(err) {
            alert(err.message);
        }
    }; 

    const onConfirmSelectUpdate = async () => {
        if (changeScheme === "yes" && !selectedMp) {
            alert("Please select the Maintenance scheme change");
            return;
        }

        try {
            if (changeScheme === "yes") {
                const confirmChange = window.confirm(
                    "Are you sure you want to change the Maintenance scheme?"
                );

                if (!confirmChange) return;
            }

            const schemeIdToSend = changeScheme === "yes" ? selectedMp : "";

            let res;
            if (transation_code_id) {
                res = await updateTransactionCodeStatus({
                    connect_program_id: program_id,
                    id: transation_code_id,
                    action: 'approve',
                    selected_scheme_id: schemeIdToSend
                })
            } else {
                res = await updateTransactionBatchStatus({
                    connect_program_id: program_id,
                    id,
                    action: 'approve',
                    selected_scheme_id: schemeIdToSend
                })
            }
            alert(res.message);
            window.location.reload();

        } catch (err) {
            alert(err.message)
        }
    }

    if (transaction_status !== "pending") {
        return <></>;
    } 

    const formContent = (
        <>
        <FormControl className={classes.formControl}>
            <FormLabel>
                <Typography>
                    Rejection Notes
                </Typography>
            </FormLabel>
            <TextField className={classes.field} 
                required={true} 
                type="text" 
                onChange={(e) => {
                    const { value } = e.target;
                    setRejectionNotes(value);
                }}
            />
        </FormControl>
        </>
    );

    const formConfirmContent = (
        <>
            <FormLabel component="div">
                <Box display="flex" alignItems="center" mb={1}>
                    <Typography style={{ fontWeight: 600, marginRight: 8 }}>
                        Initial Phase:
                    </Typography>
                    <Typography>
                        {initialOptions.find(option => option.value === initial_scheme_id)?.label || initial_scheme_id}
                    </Typography>
                </Box>

                <Box display="flex" alignItems="center">
                    <Typography style={{ fontWeight: 600, marginRight: 8 }}>
                        Maintenance Phase:
                    </Typography>
                    <Typography>
                        {maintenanceOptions.find(option => option.value === maintenance_scheme_id)?.label || maintenance_scheme_id}
                    </Typography>
                </Box>

                {transaction_type !== "free_good" && (
                    <>
                        <FormLabel component="div" style={{ marginTop: 10 }}>
                            <Typography>
                                Do you want to change the Maintenance scheme?
                            </Typography>
                        </FormLabel>

                        <Select
                            className={classes.field}
                            value={changeScheme}
                            onChange={(e) => setChangeScheme(e.target.value as string)}
                        >
                            <MenuItem value="no">No</MenuItem>
                            <MenuItem value="yes">Yes</MenuItem>
                        </Select>
                    </>
                )}
                {changeScheme === "yes" && (
                    <>
                        <FormLabel component="div" style={{ marginTop: 20 }}>
                            <Typography>
                                Change Maintenance scheme
                            </Typography>
                        </FormLabel>
                        <Select
                            className={classes.field}
                            required={true}
                            value={selectedMp}
                            onChange={(e) => setSelectedMp(e.target.value as string)}
                        >
                            <MenuItem value="">Select Scheme Change</MenuItem>
                            {maintenanceOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </>
                )}
            </FormLabel>
        </>
    );

    

    const handleClose = () => {
        setOpenModal(false);
        setRejectionNotes("");
        setConfirmation(false);
        setOpenConfirm(false);
      }

    const formButtons = (
        <>
            <Button onClick={handleClose} variant='contained'>
                Close
            </Button>
            <Button onClick={onReject} variant='contained' color='secondary'>
                Submit
            </Button>
        </>
    );

    const confirmationButton = (
        <>
            <Button onClick={handleClose} variant='contained'>
                OK
            </Button>
        </>
    );

    const formConfirmButtons = (
        <>
            <Button onClick={handleClose} variant='contained'>
                Close
            </Button>
            <Button onClick={onConfirmSelectUpdate} variant='contained' color='secondary'>
                Submit
            </Button>
        </>
    );


    return (
        <>
            <Dialog
                key='patient-registation-approval'
                open={openModal}
                title = {modalTitle}
                content = {formContent}
                children = {formButtons}
                onSubmit={onReject}
                onClose={handleClose}
            />
            <Dialog
                key='confirmation'
                open={openConfirmation}
                title = 'Confirmation'
                content = {successMessage}
                children = {confirmationButton}
                onSubmit={null}
                onClose={handleClose}
            />

            <Dialog
                key='Assign Tier Confirmation'
                open={openConfirm}
                title='Approve Patient'
                content={formConfirmContent}
                children={formConfirmButtons}
                onSubmit={null}
                onClose={handleClose}
            />

            <Button color="primary" variant="contained" onClick={() => onClick('approve')} style={{ marginRight: 8 }} >Approve</Button>
            <Button variant="contained" onClick={() => onClick('reject')} style={{ marginRight: 8 }}>Reject</Button>
        </>
    )
}

export default TransactionBatchorCodeApproval;
